export const host = "https://careerforge.onrender.com";
export const loginRoute = `${host}/api/auth/login`;
export const registerRoute = `${host}/api/auth/register`;
export const logoutRoute = `${host}/api/auth/logout`;
export const allUsersRoute = `${host}/api/messages/allusers`;
export const sendMessageRoute = `${host}/api/messages/addmsg`;
export const recieveMessageRoute = `${host}/api/messages/getmsg`;
export const SearchUsers = `${host}/api/auth/SearchUsers`;
export const getUserById=`${host}/api/auth/getUserById`;
export const sendPostRoute=`${host}/api/auth/uploadPost`;
export const getProfileData=`${host}/api/auth/getProfileData`;
export const updateProfile=`${host}/api/auth/updateProfile`;
export const checkUsernameValidity=`${host}/api/auth/checkUsernameValidity`;
export const getUserByName=`${host}/api/auth/getUserByName`;
export const getSignature=`${host}/api/auth/getSignature`;
export const setAvatarImage=`${host}/api/auth/setAvatarImage`;
export const addReaction = `${host}/api/auth/addReaction`;
export const removeReaction = `${host}/api/auth/removeReaction`;
export const addComments = `${host}/api/auth/addComment`;
export const deletePostAPI = `${host}/api/auth/deletePost`;
export const deleteCommentAPI = `${host}/api/auth/deleteComment`;
export const getPostById = `${host}/api/auth/getPostById`;
export const remConnection=`${host}/api/auth/remConnection`;
export const getConnectedUsers=`${host}/api/auth/getConnectedUsers`;
export const notConnectedUsers=`${host}/api/auth/notConnectedUsers`;
export const getAllUsers=`${host}/api/auth/getAllUser`;
export const getnotifi=`${host}/api/auth/get`;
export const getpending=`${host}/api/auth/pending`;
export const checkConnection=`${host}/api/auth/checkConnection`;
export const checkRequest=`${host}/api/auth/checkRequest`;
export const addConnection=`${host}/api/auth/addConnection`;
export const sendconnect=`${host}/api/auth/sendconnect`;
export const getAllPostsByUserId = `${host}/api/auth/getAllPostsByUserId`;
export const addSkillAPI = `${host}/api/auth/addSkill`;
export const addEndorsementAPI = `${host}/api/auth/addEndorsement`;
export const removeEndorsementAPI = `${host}/api/auth/removeEndorsement`;
export const deleteSkillAPI = `${host}/api/auth/deleteSkill`;
export const addEducationAPI = `${host}/api/auth/addEducation`;
export const deleteEducationAPI = `${host}/api/auth/deleteEducation`;
export const addExperienceAPI = `${host}/api/auth/addExperience`;
export const deleteExperienceAPI = `${host}/api/auth/deleteExperience`;
export const updateExperienceAPI = `${host}/api/auth/updateExperience`;
export const setnotifi=`${host}/api/auth/set`;
export const getMorePost=`${host}/api/auth/getMorePost`;
export const getJobsAPI=`${host}/api/getAllJobs`;
export const addJobAPI=`${host}/api/addJob`;
export const getAllPostedJobsByUserId = `${host}/api/getAllJobPostsByUserId`;
export const getJobPosterById = `${host}/api/getJobPosterById`;
export const addApplicantDetails = `${host}/api/addApplicantDetails`;
export const addAppliedJob = `${host}/api/addAppliedJob`;
export const getAppliedJobsByUserId = `${host}/api/getAppliedJobsByUserId`;
export const getStatusOfJobApplication = `${host}/api/getStatusOfJobApplication`;
export const getApplicantsDetails = `${host}/api/getApplicantsDetails`;
export const setApplicationStatus = `${host}/api/setApplicationStatus`;
export const jobemail = `${host}/api/jobemail`;
export const jobconemail = `${host}/api/jobconemail`;